export const MAP_NAMES = {
  google: "Google",
  here: "Here",
};

export const isGoogleMap = (mapName: string) => mapName === MAP_NAMES.google;
export const isHereMap = (mapName: string) => mapName === MAP_NAMES.here;
